// @ts-nocheck
import { ProductContext } from "@insite/client-framework/Components/ProductContext";
import WidgetModule from "@insite/client-framework/Types/WidgetModule";
import SupersededByComponent from "@store/Library/Components/ProductDetails/SupersededBy";
import React, { useContext } from "react";

const SupersededBy = () => {
    const { product } = useContext(ProductContext);
    if (!product.properties || !product.properties.supersededBy) {
        return null;
    }
    return <SupersededByComponent product={product} />;
};

const widgetModule: WidgetModule = {
    component: SupersededBy,
    definition: {
        displayName: "Supersede chain display",
        group: "Product Details",
        allowedContexts: ["ProductDetailsPage"],
    },
};

export default widgetModule;
